import type { DisclaimerBannerStyleCore } from './types';

// export this to ensure any update here to be effective for all customized disclaimer banners
// which consume this style
export const getDisclaimerBannerStyle = (_: unknown, { palette = {} }: DisclaimerBannerStyleCore = {}) => ({
  disclaimer: {
    fontSize: 12,
    color: '#323130',
    marginTop: 16,
    marginBottom: 16,
    paddingLeft: 32,
    '& span': {
      '& a.HelpTopic, & a.Fwlink, & a.DelegateLink': {
        textDecoration: 'underline',
        color: '#0072c9',
        '&:focus': {
          textDecoration: 'underline',
          outline: `1px solid ${palette.neutralSecondary}`,
        },
        '&:hover': {
          textDecoration: 'underline',
          color: palette.themeDarker,
        },
      },
    },
  },
});
